/* global jQuery COMPONENTS */
COMPONENTS.ComponentEvent = (function ($) {
  function ComponentEvent () {
    this.calendarWrap = document.getElementById('ecs-events-calender')
    this.$calendar = $(this.calendarWrap)
    this.listWrap = document.getElementById('ecs-events-list')
    this.listBody = document.getElementById('ecs-events-list-body')
    this.scrollUpBtn = document.getElementById('ecs-events-list-scroll-up')
    this.ec = null
    this.currentMonthIndex = 0
    this.monthKeys = []
    this.activeMonthKey = this.getMonthKey(new Date())
  }

  ComponentEvent.prototype.init = function () {
    if (!$('#ecs-events-calender').length) return

    const self = this
    const viewportTablet = window.matchMedia('(min-width: 768px)')
    const urlParams = new URLSearchParams(window.location.search)
    const savedView = urlParams.get('view')
    const savedMonth = self.getValidMonthKey(urlParams.get('month'))
    const initialDate = savedMonth ? savedMonth + '-01' : null
    const calendarOptions = {
      view: 'dayGridMonth',
      headerToolbar: { start: 'prev', center: 'title', end: 'today next' },
      events: events,
      editable: false,
      eventStartEditable: false,
      eventDurationEditable: false,
      eventClick: function (info) {
        // occurrence_id format: "{post-slug}--{timestamp}" — extract slug before the double dash
        const occurrenceId = info.event.id
        const slug = (info.event.extendedProps && info.event.extendedProps.slug)
          ? info.event.extendedProps.slug
          : occurrenceId.split('--')[0]

        if (!viewportTablet.matches) {
          let eventCardEl = document.getElementById(occurrenceId)
          if (!eventCardEl) {
            const eventDate = self.getDateKey(info.event.start)
            eventCardEl = document.querySelector('.ecs_event_mini_card[data-slug="' + slug + '"][data-date="' + eventDate + '"]')
          }
          if (!eventCardEl) {
            eventCardEl = document.querySelector('.ecs_event_mini_card[data-slug="' + slug + '"]')
          }
          if (!eventCardEl) {
            return
          }

          eventCardEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
          $('.ec-day').removeClass('ecs_active')
          $('.ecs_event_mini_card').removeClass('ecs_active')
          $(info.el).parent().parent().addClass('ecs_active')
          $(eventCardEl).addClass('ecs_active')
        } else {
          let baseURL = window.location.origin + window.location.pathname
          const eventMonth = self.getMonthKey(info.event.start)
          window.location.href = baseURL + slug + '?view=calendar&month=' + eventMonth
        }
      }
    }

    if (savedMonth) {
      self.activeMonthKey = savedMonth
      calendarOptions.date = initialDate
    }

    // Initialise the EventCalendar library for dayGridMonth only
    self.ec = EventCalendar.create(document.getElementById('ecs-events-calender'), calendarOptions)

    self.bindCalendarNavHandlers()

    // Prepare custom list view (collect months, determine start month)
    self.initListView()

    // View toggle
    const $viewToggle = $('.ecs_event_view_toggle__btn')
    if ($viewToggle.length) {
      $viewToggle.on('click', function () {
        const view = $(this).data('view')
        $viewToggle.removeClass('is-active').attr('aria-pressed', 'false')
        $(this).addClass('is-active').attr('aria-pressed', 'true')

        if (view === 'listMonth') {
          // Switch to custom list
          $(self.calendarWrap).hide()
          if (self.listWrap) self.listWrap.removeAttribute('hidden')
          $('#ecs-events-calender-cards').addClass('ecs_event_calendar_cards--hidden')
          // Defer scroll-to-today until the element is visible in the DOM
          requestAnimationFrame(function () {
            self.showMonth(self.currentMonthIndex, true)
          })
          self.setViewParam('list')
        } else {
          // Switch to EC calendar
          $(self.calendarWrap).show()
          if (self.listWrap) self.listWrap.setAttribute('hidden', true)
          $('#ecs-events-calender-cards').toggleClass('ecs_event_calendar_cards--hidden', view !== 'dayGridMonth')
          self.ec.setOption('view', view)
          self.setViewParam('calendar')
        }
      })

      // Restore view from URL param (e.g. when returning from a single event page)
      if (savedView === 'list') {
        $viewToggle.filter('[data-view="listMonth"]').trigger('click')
      } else {
        // Default: calendar view — seed card links so they carry ?view=calendar
        self.updateCardLinks('calendar')
      }
    }
  }

  /**
   * Collect all month keys from the DOM and wire up navigation and scroll events.
   * Called once during init; does not scroll (list is hidden at this point).
   */
  ComponentEvent.prototype.initListView = function () {
    const self = this

    console.log('Initializing list view')

    if (!self.listWrap) return

    // Collect months in document order
    self.monthKeys = []
    $('.ecs_event_list_month').each(function () {
      self.monthKeys.push($(this).data('month'))
    })

    if (!self.monthKeys.length) return

    // Determine starting month: prefer current calendar month, else first future month
    const today = new Date()
    const todayMonthKey = self.getMonthKey(today)
    let startIndex = self.monthKeys.indexOf(todayMonthKey)

    if (startIndex === -1) {
      startIndex = 0
      for (let i = 0; i < self.monthKeys.length; i++) {
        if (self.monthKeys[i] >= todayMonthKey) {
          startIndex = i
          break
        }
      }
    }

    const savedMonth = self.getMonthParam()
    if (savedMonth) {
      const savedMonthIndex = self.monthKeys.indexOf(savedMonth)
      if (savedMonthIndex !== -1) {
        startIndex = savedMonthIndex
      }
    }

    self.currentMonthIndex = startIndex

    // Prev / Next navigation
    $('.ecs_event_list_prev').on('click', function () {
      if (self.currentMonthIndex > 0) {
        self.currentMonthIndex--
        self.showMonth(self.currentMonthIndex, true)
      }
    })

    $('.ecs_event_list_next').on('click', function () {
      if (self.currentMonthIndex < self.monthKeys.length - 1) {
        self.currentMonthIndex++
        self.showMonth(self.currentMonthIndex, true)
      }
    })

    // Scroll-up button: show when the body has been scrolled away from the top
    if (self.listBody && self.scrollUpBtn) {
      self.listBody.addEventListener('scroll', function () {
        if (self.listBody.scrollTop > 10) {
          self.scrollUpBtn.classList.add('is-visible')
        } else {
          self.scrollUpBtn.classList.remove('is-visible')
        }
      })

      self.scrollUpBtn.addEventListener('click', function () {
        self.listBody.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  }

  /**
   * Show the month at the given index.
   *
   * @param {number}  index             Index into this.monthKeys.
   * @param {boolean} shouldScrollToday When true and the month is the current
   *                                    calendar month, scroll to the first
   *                                    today-or-future event.
   */
  ComponentEvent.prototype.showMonth = function (index, shouldScrollToday) {
    const self = this
    const monthKey = self.monthKeys[index]

    // Hide all months then reveal the target
    $('.ecs_event_list_month').attr('hidden', true)
    const $month = $('.ecs_event_list_month[data-month="' + monthKey + '"]')
    $month.removeAttr('hidden')
    this.activeMonthKey = monthKey

    // Update toolbar title
    const label = $month.data('label') || monthKey
    $('.ecs_event_list_title').text(label)

    // Disable nav buttons at boundaries
    $('.ecs_event_list_prev').prop('disabled', index === 0)
    $('.ecs_event_list_next').prop('disabled', index === self.monthKeys.length - 1)

    // Reset scroll and hide the scroll-up indicator
    if (self.listBody) self.listBody.scrollTop = 0
    if (self.scrollUpBtn) self.scrollUpBtn.classList.remove('is-visible')

    // Optionally scroll to today (only meaningful for the current month)
    if (shouldScrollToday && monthKey === self.getMonthKey(new Date())) {
      self.scrollToToday()
    }

    self.setMonthParam(monthKey)
    self.updateCardLinks('list')
  }

  /**
   * Scroll the list body so that the first event on or after today is at the
   * top of the visible area.
   */
  ComponentEvent.prototype.scrollToToday = function () {
    const self = this
    if (!self.listBody) return

    const today = new Date()
    const todayStr = self.getDateKey(today)

    let targetEl = null
    $('.ecs_event_list_month:not([hidden]) .ecs_event_list_row').each(function () {
      if (!targetEl && $(this).data('date') >= todayStr) {
        targetEl = this
      }
    })

    if (targetEl) {
      // Anchor to the day group so the date header is visible at the top
      const anchorEl = targetEl.closest('.ecs_event_list_day') || targetEl
      const bodyRect = self.listBody.getBoundingClientRect()
      const anchorRect = anchorEl.getBoundingClientRect()
      const scrollOffset = self.listBody.scrollTop + (anchorRect.top - bodyRect.top)
      self.listBody.scrollTop = Math.max(0, scrollOffset)
    }
  }

  /** Updates the ?view= URL param without triggering a page reload. */
  ComponentEvent.prototype.setViewParam = function (view) {
    const url = new URL(window.location.href)
    url.searchParams.set('view', view)
    history.replaceState(null, '', url.toString())
    this.updateCardLinks(view)
  }

  ComponentEvent.prototype.setMonthParam = function (monthKey) {
    if (!this.getValidMonthKey(monthKey)) return
    const url = new URL(window.location.href)
    url.searchParams.set('month', monthKey)
    history.replaceState(null, '', url.toString())
  }

  ComponentEvent.prototype.getMonthParam = function () {
    const url = new URL(window.location.href)
    return this.getValidMonthKey(url.searchParams.get('month'))
  }

  ComponentEvent.prototype.getValidMonthKey = function (monthKey) {
    return /^\d{4}-\d{2}$/.test(monthKey || '') ? monthKey : null
  }

  /**
   * Updates all ecs_event_card_link hrefs to carry the current view param
   * so that navigating from a card always returns to the correct view.
   *
   * @param {string} view 'calendar' or 'list'
   */
  ComponentEvent.prototype.updateCardLinks = function (view) {
    const activeMonth = this.activeMonthKey || this.getMonthKey(new Date())

    $('.ecs_event_card_link, .ecs_event_mini_card_link').each(function () {
      const linkUrl = new URL(this.href, window.location.origin)
      linkUrl.searchParams.set('view', view)
      linkUrl.searchParams.set('month', activeMonth)
      this.href = linkUrl.toString()
    })
  }

  ComponentEvent.prototype.bindCalendarNavHandlers = function () {
    const self = this

    $(document).on('click', '#ecs-events-calender .ec-prev, #ecs-events-calender .ec-next, #ecs-events-calender .ec-today', function () {
      setTimeout(function () {
        const monthKey = self.resolveCurrentCalendarMonthKey()
        if (monthKey) {
          self.activeMonthKey = monthKey
          self.setMonthParam(monthKey)
          self.updateCardLinks('calendar')
        }
      }, 0)
    })
  }

  ComponentEvent.prototype.resolveCurrentCalendarMonthKey = function () {
    if (this.ec && typeof this.ec.getDate === 'function') {
      return this.getMonthKey(this.ec.getDate())
    }

    const title = document.querySelector('#ecs-events-calender .ec-title')
    if (!title) {
      return this.activeMonthKey
    }

    const monthMatch = title.textContent.trim().match(/^(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{4})$/)
    if (!monthMatch) {
      return this.activeMonthKey
    }

    const monthMap = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12'
    }

    return monthMatch[2] + '-' + monthMap[monthMatch[1]]
  }

  /** Returns 'YYYY-MM' for a Date object. */
  ComponentEvent.prototype.getMonthKey = function (date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0')
  }

  /** Returns 'YYYY-MM-DD' for a Date object. */
  ComponentEvent.prototype.getDateKey = function (date) {
    return (
      date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0')
    )
  }

  return ComponentEvent
})(jQuery)

COMPONENTS.componentEvent = COMPONENTS.ComponentEvent

document.addEventListener('components_init', function (e) {
  if (!(COMPONENTS.componentEventInstance instanceof COMPONENTS.ComponentEvent)) {
    COMPONENTS.componentEventInstance = new COMPONENTS.ComponentEvent()
  }
  COMPONENTS.componentEventInstance.init()
})
